<script>
import { mapActions } from 'vuex'
import { pick } from 'lodash-es'

export default {
    name: 'CouponRedeemFormBase',
    data() {
        return {
            code: '',
            errors: null,
        }
    },
    created() {
        this.$bus.$on('coupon-redeem-error', (error) => {
            const _errors = error.response.data.errors
            this.errors = _errors
            if ( typeof _errors === 'object' ) { 
                let result = []
                Object.keys(_errors).forEach((key) => result.push(_errors[key]) )
                this.errors = result
            }
        })

        this.$bus.$on('coupon-redeemed', () => {
            this.code = ''
            this.errors = null
        })
    },
    methods: {
        ...mapActions('cart', [
            'redeemCoupon'
        ]),
        updateCode(event) {
            this.code = event.target.value
        }
    },
    render() {
        return this.$scopedSlots.default(
            pick(this, ['redeemCoupon', 'code', 'errors', 'updateCode'])
        )
    }
}
</script>